export default __webpack_public_path__ + "static/media/flag-el.77154ab8.svg";